const common = {
  no_data_title: 'No data found',
  no_data_description: 'There are no records to display.',
  loading: 'Loading...',
  error: 'An error occurred',
  success: 'Operation completed successfully',
  confirm: 'Confirm',
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  edit: 'Edit',
  create: 'Create',
  search: 'Search',
  filter: 'Filter',
  export: 'Export',
  help: 'Help',
  export_empty: 'There is no data to export with the current filters',
  row_actions: 'Actions',
  weekdays: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
  filters: {
    label: 'Filters',
    search: 'Search',
    show: 'Show filters',
    hide: 'Hide filters',
  },
  nav: {
    // Rail entries that open onto several screens. A section with a single
    // visible screen borrows that screen's own name instead.
    sections: {
      calls: 'Calls',
      team: 'Team',
      clients: 'Clients',
      settings: 'Settings',
    },
  },
  menu: {
    // Short role hints shown as tooltips so the role model is obvious at a
    // glance: who answers calls vs who owns the account (roadmap #54).
    tooltips: {
      staff: 'Agents who answer calls',
      clients: 'Account holders',
      orgManagers: 'Manage an organization',
    },
  },
  impersonation: {
    action: 'Impersonate user',
    active: 'Acting as %{name}',
    exit: 'Exit',
  },
  staffCaller: {
    button: 'Receive calls',
  },
  clear: 'Clear',
  yes: 'Yes',
  no: 'No',
  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
  },
  notifications: {
    session_extended_success: 'Session extended successfully',
    session_expired: 'Your session has expired. Please log in again.',
    connection_error: 'Connection error. Please check your internet connection.',
    server_error: 'Server error. Please try again later.',
    save_success: 'Data saved successfully',
    save_error: 'Error saving data',
    delete_success: 'Item deleted successfully',
    delete_error: 'Error deleting item',
  },
  validation: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    minLength: 'Must be at least %{min} characters',
    maxLength: 'Must be no more than %{max} characters',
    number: 'Must be a valid number',
    positive: 'Must be a positive number',
    unique: 'This value already exists',
  },
};

export default common;
